export default defineNuxtRouteMiddleware(async (to, from) => {
  const { sendEvent } = useAnalytics()
  sendEvent('navigation', { from: from.fullPath, to: to.fullPath })
})
